import React from "react";
import { BASE_URL_MEDIA } from "../../../../api/Constants";

const AddEditProgress = ({
  handleCloseForm,
  bmi,
  setBmi,
  weight,
  setWeight,

  desc,
  setDesc,
  selectedImages,
  setSelectedImages,
  newImages,
  setNewImages,
  porgressType,
  setProgressType,
  editStatus,
  handleSubmit,
  deleteBodyChangeImage,
  addEditLoader,
}) => {
  const onSelectFile = (event) => {
    const selectedFilesArray = Array.from(event.target.files);
    setNewImages((previousImages) => previousImages.concat(selectedFilesArray));
    event.target.value = "";
  };

  function deleteHandler(type, image) {
    const confirmed = window.confirm("Do you want to remove this Image?");
    if (confirmed) {
      if (type === 1) {
        setNewImages(newImages.filter((e) => e !== image));
        URL.revokeObjectURL(image);
      } else {
        setSelectedImages(selectedImages.filter((e) => e.id !== image.id));
        deleteBodyChangeImage(image.id);
      }
    }
  }

  // waiting Loader
  const loader = () => {
    return (
      <div class="three-body">
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
      </div>
    );
  };

  return (
    <div className="trainer-modal-eventWrapper trainer-modal-eventWrapper-upper ">
      <div className="trainer-modal trainer-modal-lg add-edit-precess">
        <div className="close" onClick={() => handleCloseForm()}>
          <i className="fa fa-times"></i>
        </div>
        <div className="stats-head">
          <p>{editStatus ? `Edit` : `Add New `} Progress</p>
          <div className="radio-button-container">
            <div
              className="radio-button"
              onClick={() => setProgressType("pre")}
            >
              <input
                type="radio"
                className="radio-button__input"
                id="radio1"
                name="radio-group"
                checked={porgressType === "pre"}
              />
              <label className="radio-button__label" for="radio1">
                <span className="radio-button__custom"></span>
                Before Program
              </label>
            </div>
            <div
              className="radio-button"
              onClick={() => setProgressType("post")}
            >
              <input
                type="radio"
                className="radio-button__input"
                id="radio2"
                name="radio-group"
                checked={porgressType === "post"}
              />
              <label className="radio-button__label" for="radio2">
                <span className="radio-button__custom"></span>
                After Program
              </label>
            </div>
          </div>
        </div>
        <div className="body-section">
          <div className="form-group relative input-feilds input-stats-section">
            <div className="input-stats-1">
              <div className="input-stats">
                <label htmlFor="id167">Enter Weight</label>
                <input
                  id="id167"
                  type="number"
                  className="input"
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                />
              </div>
              <div className="input-stats">
                <label htmlFor="id167">Enter BMI</label>
                <input
                  id="id167"
                  type="number"
                  className="input"
                  value={bmi}
                  onChange={(e) => setBmi(e.target.value)}
                />
              </div>
            </div>
            <div className="input-stats-2">
              <div className="input-stats">
                <label htmlFor="id167">Enter Description</label>
                <textarea
                  id="id167"
                  className="input textarea-desc"
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="image-section">
            <div className="upload-image">
              <form className="file-upload-form">
                <label for="file" className="file-upload-label">
                  <div className="file-upload-design">
                    <svg viewBox="0 0 640 512" height="1em">
                      <path d="M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"></path>
                    </svg>
                    <p>Drag and Drop</p>

                    <span className="browse-button">Browse Images</span>
                  </div>
                  <input
                    type="file"
                    id="file"
                    accept="image/*"
                    multiple
                    onChange={onSelectFile}
                  />
                </label>
              </form>
            </div>
          </div>

          <div className="progess-added-images">
            {selectedImages &&
              editStatus &&
              selectedImages.map((image, index) => (
                <div key={image} className="progress-image">
                  <div className="delete-box">
                    <i
                      className="fa fa-times delete"
                      onClick={() => deleteHandler(2, image)}
                    ></i>
                  </div>
                  <img
                    src={`${BASE_URL_MEDIA}/storage/assets/uploads/${image.image}`}
                    height="200"
                    alt="upload"
                  />
                </div>
              ))}
            {newImages &&
              newImages.map((image, index) => (
                <div key={image} className="progress-image">
                  <div className="delete-box">
                    <i
                      className="fa fa-times delete"
                      onClick={() => deleteHandler(1, image)}
                    ></i>
                  </div>
                  <img
                    src={URL.createObjectURL(image)}
                    height="200"
                    alt="upload"
                  />
                </div>
              ))}
          </div>
        </div>

        <div className="progress-btn-section">
          {!addEditLoader ? (
            <div className="progress-save-button" onClick={handleSubmit}>
              Save
            </div>
          ) : (
            <div className="progres-save-loader">{loader()}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddEditProgress;
